import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IQuoteFormState {
  deliverySpeed: "inventory" | "adsp" | "";
  isLookingForExchange: boolean | null;
  isInterestedInFinance: boolean | null;
  carAccessories: string[];
  preferredNumberPlate: string;
  selectedColor: string;
  selectedVariant: string;
}

const initialState: IQuoteFormState = {
  deliverySpeed: "",
  isLookingForExchange: null,
  isInterestedInFinance: null,
  carAccessories: [],
  preferredNumberPlate: "",
  selectedColor: "",
  selectedVariant: "",
};

const quoteFormSlice = createSlice({
  name: "quoteForm",
  initialState,
  reducers: {
    setDeliverySpeed: (state, action: PayloadAction<"inventory" | "adsp">) => {
      state.deliverySpeed = action.payload;
    },
    setIsLookingForExchange: (state, action: PayloadAction<boolean>) => {
      state.isLookingForExchange = action.payload;
    },
    setIsInterestedInFinance: (state, action: PayloadAction<boolean>) => {
      state.isInterestedInFinance = action.payload;
    },
    setCarAccessories: (state, action: PayloadAction<string[]>) => {
      state.carAccessories = action.payload;
    },
    setPreferredNumberPlate: (state, action: PayloadAction<string>) => {
      state.preferredNumberPlate = action.payload;
    },
    resetForm: (state) => {
      return initialState;
    },
  },
});

export const hasStepValue = (
  step: number,
  formState: IQuoteFormState
): boolean => {
  switch (step) {
    case 1:
      return formState.deliverySpeed !== "";
    case 2:
      return formState.isLookingForExchange !== null;
    case 3:
      return formState.isInterestedInFinance !== null;
    case 4:
      return formState.carAccessories.length > 0;
    case 5:
      return formState.preferredNumberPlate.trim() !== "";
    default:
      return false;
  }
};

export const {
  setDeliverySpeed,
  setIsLookingForExchange,
  setIsInterestedInFinance,
  setCarAccessories,
  setPreferredNumberPlate,
  resetForm,
} = quoteFormSlice.actions;

export default quoteFormSlice.reducer;
